import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import NewsCard from "@/components/NewsCard";
import { api } from "@/lib/api";

export default function SearchPage() {
  const [params] = useSearchParams();
  const q = params.get("q") || "";
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!q) { setItems([]); setLoading(false); return; }
    setLoading(true);
    api.get("/articles", { params: { q, limit: 60 } })
      .then((r) => setItems(r.data.items || []))
      .finally(() => setLoading(false));
  }, [q]);

  return (
    <>
      <Header />
      <main className="max-w-[1440px] mx-auto px-4 md:px-8 py-10" data-testid="search-page">
        <p className="overline accent-text mb-2">BÚSQUEDA</p>
        <h1 className="font-headline uppercase text-3xl md:text-5xl mb-2">
          {q || "Escribí algo para buscar"}
        </h1>
        <p className="mb-8" style={{ color: "var(--text-muted)" }}>
          {!loading && q && `${items.length} resultado${items.length === 1 ? "" : "s"}`}
        </p>
        {loading ? (
          <p>Buscando...</p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-6 gap-y-10">
            {items.map((a) => <NewsCard key={a.id} article={a} />)}
          </div>
        )}
      </main>
      <Footer />
    </>
  );
}
